const PlayerAppStates = {
  IDLE: 'idle',
  INTRO: 'intro',
  PLAYING: 'playing',
  ENDING: 'ending',
};

module.exports = PlayerAppStates;
